export const CUSTOM_COMPONENT_CALCULATOR = 'calculator';
export const CUSTOM_COMPONENT_OFFICES_MAP = 'officesMap';
export const CUSTOM_COMPONENT_SUBSCRIBE_FORM = 'subscribeForm';
export const CUSTOM_COMPONENT_VOTE_FORM = 'voteForm';
